// removed by extract-text-webpack-plugin
module.exports = {"box":"route-signs-popup--box--2T09fjnT","example":"route-signs-popup--example--2c_DIbmM"};


//////////////////
// WEBPACK FOOTER
// ./components/route-signs-popup/styles.css
// module id = ./components/route-signs-popup/styles.css
// module chunks = 0